/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../Store';

const self = (state: RootState) => state.footer;

export const getBuyCurrency = createSelector(self, (state) => state.buyCurrency);
export const getLink = createSelector(self, (state) => state.link);
